<template>
  <div
v-if="isOpen"
    class="fixed inset-0 bg-gray-500 bg-opacity-30 flex items-center justify-center z-50 p-4 text-sm fadeIn"
  >
    <div class="modal bg-white p-4 rounded-md shadow-md">
      <span class="font-semibold block">Are you sure you want to delete this job?</span>
      <span class="italic mt-4 block font-bold text-red-500"
        >Deleting this job will delete all other users' applications for this job</span
      >
      <span class="italic block">This action cannot be undone. Consider setting the job to 'closed' instead</span>
      <div class="flex items-center justify-end gap-2 mt-4">
        <button
          @click="cancelDelete"
          class="border-[1px] border-gray-200 text-black px-4 py-2 rounded-md hover:bg-gray-200 transition-all duration-200"
        >
          Cancel
        </button>
        <button
          @click="deleteApplication"
          class="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-all duration-200"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
import { useRolesStore } from '@/stores/roles'
import { useToast } from '@/components/ui/toast/use-toast'

const router = useRouter()
const rolesStore = useRolesStore()
const { toast } = useToast()

const props = defineProps({
  roleId: {
    type: String,
    required: true
  },
  isOpen: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits(['close'])

const deleteApplication = async () => {
  try {
    await rolesStore.deleteRole(props.roleId)
    toast({ title: 'Success', description: 'Job deleted successfully' })
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.push('/jobs')
  } catch (error) {
    console.error('Failed to delete:', error)
    toast({ variant: 'destructive', title: 'Error', description: 'Failed to delete job' })
  }
}

const cancelDelete = () => {
  emit('close')
}
</script>
